import { Group, Text } from '@mantine/core'
import { IconCopy, IconUserPlus } from '@tabler/icons-react'
import { forwardRef } from 'react'

interface ShareSelectItemProps extends React.ComponentPropsWithoutRef<'div'> {
  label: string
  description: string
  icon?: string
}

export const ShareSelectItem = forwardRef<HTMLDivElement, ShareSelectItemProps>(
  ({ label, description, icon, ...others }, ref) => (
    <div ref={ref} {...others}>
      <Group noWrap spacing="sm" align="center">
        {icon === 'copy' && <IconCopy size={24} stroke={1.5} color="#868e96" />}
        {icon === 'co_teacher' && <IconUserPlus size={24} stroke={1.5} color="#868e96" />}
        <div>
          <Text size="sm" weight={500}>{label}</Text>
          <Text size="xs" color="dimmed">{description}</Text>
        </div>
      </Group>
    </div>
  ),
)
ShareSelectItem.displayName = 'ShareSelectItem'
